import {useCallback} from 'react';
import untickExpiredTodosDoc from '../../api/todo/untickExpiredTodosDoc';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export default function useUntickExpiredTodos(uid: string | undefined) {
  const untickFn = useCallback(
    (todoIds: string[]) => {
      if (!uid) throw new Error('Todo collection not found');
      return untickExpiredTodosDoc(uid, todoIds);
    },
    [uid],
  );
  const {fn, loading, error} = useFunctionWrap(untickFn);

  return {
    untickExpiredTodos: fn,
    loading,
    error,
  };
}
